export default __webpack_public_path__ + "static/media/goog-3.e519e377.jfif";